import React from 'react';
import { useTranslation } from 'react-i18next';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { useNavigate } from "react-router-dom";

import { BackTo } from './styles';

type Props = {
  url: string;
}

const BackToPreviousPage: React.FC<Props> = ({
  url
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const clickCheck = (redirectUrl: string) => {
    navigate(redirectUrl);
  }

  return(
    <BackTo onClick={() => clickCheck(url)} >
      <KeyboardArrowLeftIcon /> {t('back_to')}
    </BackTo>
  )
}

export default BackToPreviousPage;